<template>
  <v-expansion-panels
    variant="accordion"
    :value="groupData.open_by_default ? 0 : undefined"
  >
    <v-expansion-panel>
      <v-expansion-panel-header>{{
        groupData.panel_title
      }}</v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-container fluid class="pa-0" data-testid="hotspot-group">
          <!--<span class="text-caption">{{ groupData.title }}</span>-->
          <v-radio-group
            v-if="groupData.selected_groups.group_item_type == 'radioBtn'"
            v-model="radioGroupValue"
            color="primary"
            mandatory
            class="mt-0"
          >
            <v-list-item
              v-for="(item, i) in groupData.selected_groups.layers"
              :key="i"
              color="primary"
            >
              <v-list-item-content>
                <v-list-item-title>
                  <v-radio :color="primaryColor" :label="item.title" :value="item.id" :data-testid="'hotspot-group-radio'+i"> </v-radio>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-radio-group>

          <v-list v-if="groupData.selected_groups.group_item_type == 'checkBox'">
            <v-list-item-group
              class="mt-0"
              color="primary"
              v-for="(item, i) in groupData.selected_groups.layers"
              :key="`layer-${i}`"
            >
              <!-- Group with Checkbox as Header and Activator -->
              <v-list-group no-action :key="`group-${i}`" :data-testid="'hotspot-group-checkbox' + i">
                <template v-slot:activator>
                  <v-list-item :data-testid="'hotspot-group-checkbox-option' + i">
                    <v-list-item-content>
                      <v-list-item-title :data-testid="'hotspot-group-checkbox-title' + i"
                        v-text="item.title"
                      ></v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-checkbox
                        :color="secondaryColor"
                        :input-value="checkboxGroupValue.includes(item.id)"
                        @change="handleCheckboxChange(item.id, $event)"
                        @click.stop
                        :data-testid="'hotspot-group-checkbox-input'+i"
                      ></v-checkbox>
                    </v-list-item-action>
                  </v-list-item>
                </template>

                <!-- Nested List Items -->
                <v-list-item
                  v-for="(item2, i2) in item.locations"
                  :key="`item-${i}-${i2}`"
                  @click="listItemClick(item2)"
                  v-model="activeListItemId"
                >
                  <v-list-item-content>
                    <v-list-item-title v-text="item2.title" :data-testid="'hotspot-group-option' + i2"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </v-list-item-group>
          </v-list>
        </v-container>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { isWhite } from "../../util/color";
import StreamfieldBlock from "../blocks/streamfieldBlock.vue";

export default {
  props: ["groupData"],
  components: {
    StreamfieldBlock,
  },
  data: () => ({
    radioGroupValue: 0,
    checkboxGroupValue: [],
    checked: false,
    selectedItem: 0,
    activeCheckboxes: [],
    activelocation: null,
    activeListItemId: null,
  }),
  mounted() {

    if (this.groupData.selected_groups.group_item_type === 'checkBox') {

      const checkboxValue = this.groupData.selected_groups.layers
        .filter((layer) => layer.visible_by_default)
        .map((layer) => layer.id);

      this.checkboxGroupValue = checkboxValue

    } else {

      const radioValue = this.groupData.selected_groups.layers[0].id
      this.radioGroupValue = radioValue

    }
  },
  beforeCreate: function () {
    this.$options.components.StreamfieldBlock =
      require("../blocks/streamfieldBlock.vue").default;
  },
  methods: {
    updateStore(value) {
      console.log('[SELECT GROUP UPDATE STORE]')
      this.$store.commit("wagtail/setVisibleHotspotGroups", [value]);
    },
    updateStoreCheckbox(value) {
      console.log('[SELECT UPDATE STORE CHECK]')
      this.$store.commit(
        "wagtail/setVisibleHotspotGroups",
        value
      );
    },
    listItemClick(item) {
      const center = [Number(item.lng), Number(item.lat)];
      /* FIX ZOOM to use new zoom field not magic number*/
      let zoom = Number(0)
      if (item.zoom != null) {
        zoom = Number(item.zoom);
      } else {
        zoom = Number(18);
      }

      const payload = {
        zoomLevel: zoom,
        location: {
          lng: item.lng,
          lat: item.lat,
        },
        tilt_offset: 0,
        heading: 0,
      };

      this.activeListItemId = item.id;

      this.$root.$emit('clear-render-view-2d');
      if (item.right_sidebar_content.length > 0) {
        console.log(item, "item data of clicked");
        this.$store.commit("map/setGroupLocation", item);
        this.$store.commit("map/setRightSidebarZoomLevel", item.zoom);
        this.$store.commit("map/setRenderLocation", null);
        this.$store.commit("map/setPrecinct", null);
      }
      this.$store.commit("map/setHotspotGroupSelectedLocation", payload);

      const itemGroup = this.groupData.selected_groups.layers.find((group) => {
        return group.locations.find((groupItem) => groupItem.id === item.id)
      })


      if(itemGroup) {
        if (!this.checkboxGroupValue.includes(itemGroup.id)) {
          this.checkboxGroupValue.push(itemGroup.id)
        }
      }

    },
    handleCheckboxChange(itemId, isChecked) {
      if (isChecked && !this.checkboxGroupValue.includes(itemId)) {
        this.checkboxGroupValue.push(itemId);
        console.log("TRACK Updating", itemId, "is checked");
      } else if (!isChecked && this.checkboxGroupValue.includes(itemId)) {
        this.checkboxGroupValue = this.checkboxGroupValue.filter(
          (id) => id !== itemId
        );
        console.log("TRACK Updating", itemId, "is not checked");
      }
    },
  },
  created() {

  },
  computed: {
    primaryColor() {
      if (isWhite(this.$vuetify.theme.themes.light.primary)) {
        return '#000000'
      } else {
        return this.$vuetify.theme.themes.light.primary
      }
    },

    secondaryColor() {

      if (isWhite(this.$vuetify.theme.themes.light.secondary)) {
        return '#000000'
      } else {
        return this.$vuetify.theme.themes.light.secondary
      }

    },
    
    hotspotGroupSelectedLocation() {
      return this.$store.state.map.hotspotGroupSelectedLocation;
    },
    layerOptions() {
      return this.$store.state.wagtail.layerOptions;
    },
  },
  watch: {
    hotspotGroupSelectedLocation: function (value) {
        console.log('[SELECT GROUP CHANGE SELECT]', value)
      if (value == null) {
        this.activeListItemId = null;
      }
    },
    radioGroupValue(newVal) {
      console.log('[SELECT GROUP RGV]', newVal)
      this.updateStore(newVal);
    },
    data: function (newVal) {
      console.log('[SELECT GROUP datastore]', newVal)      
    },
    checkboxGroupValue: {
      handler(newVal) {
        console.log('[SELECT GROUP CHECKGROUPVALUE]', newVal)   
        this.activeCheckboxes = [...newVal]; // Update the array with the current active checkboxes
        this.updateStoreCheckbox(this.activeCheckboxes);
      },
      deep: true, // Use deep watcher to detect changes inside the array
    },
  },
  beforeDestroy() {
    let payload = { key: this._uid, data: null };
    this.$store.commit("wagtail/setLayerOptions", payload);
  },
};
</script>

<style scoped>
.radio-bg {
  background-color: rgb(229, 229, 229);
}
.subheader-checkbox {
  /* Adjust these styles as needed */
  display: inline-block;
  vertical-align: middle;
}
</style>
